import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/internal/customer-management/_layout/")({
  beforeLoad: () => {
    throw redirect({ to: "/internal/customer-management/organizations" })
  },
})
